// @ts-nocheck
import React from 'react'
import Edit from '../crud/edit'
import fields from './fields'
import menuItems from './menuItems'
import CalendarControl from '../event-calendar-control'

const EditSessionSale = props => {
  const { sessionSaleId } = props.params

  return (
    <div>
      <Edit
// @ts-ignore
        title='Edit Session Sale'
        fields={fields}
        apiPath={`admin/session_sales/${sessionSaleId}`}
        successRedirectPath='/events/session-sales'
        buildMenuItems={r => menuItems(r, true)}
      />
      <CalendarControl targetId={sessionSaleId} targetType='session_sale' />
    </div>
  )
}

export default EditSessionSale
